import axios from "axios";
import {
  createPlanUrl,
  getPlansListUrl,
  getAllAdvisorSubscriptionsUrl,
  createExamUrl,
  updateExamUrl,
  deleteExamUrl,
  getExamFullUrl,
  addExamQuestionUrl,
  listExamsAdminUrl,
  getAllReferralsUrl,
  markReferralConvertedUrl,
  listJourneysUrl,
  toggleJourneyUrl,
  updateJourneyStepUrl,
} from "../utils/urls";

// ---------- plans ----------
export const createPlan = async (payload) =>
  (await axios.post(createPlanUrl, payload))?.data;
export const getPlansList = async (params = {}) =>
  (await axios.get(getPlansListUrl, { params }))?.data;
export const getAllAdvisorSubscriptions = async (params = {}) =>
  (await axios.get(getAllAdvisorSubscriptionsUrl, { params }))?.data?.data;

// ---------- certification ----------
export const createExam = async (payload) =>
  (await axios.post(createExamUrl, payload))?.data?.data;
export const updateExam = async (id, patch) =>
  (await axios.put(updateExamUrl(id), patch))?.data?.data;
export const deleteExam = async (id) => (await axios.delete(deleteExamUrl(id)))?.data;
export const getExamFull = async (id) => (await axios.get(getExamFullUrl(id)))?.data?.data;
export const addExamQuestion = async (id, q) =>
  (await axios.post(addExamQuestionUrl(id), q))?.data?.data;
export const listExamsAdmin = async () =>
  (await axios.get(listExamsAdminUrl))?.data?.data;

// ---------- referral ----------
export const getAllReferrals = async (params = {}) =>
  (await axios.get(getAllReferralsUrl, { params }))?.data?.data;
export const markReferralConverted = async (referred_advisor_id) =>
  (await axios.post(markReferralConvertedUrl, { referred_advisor_id }))?.data?.data;

// ---------- journeys ----------
export const listJourneys = async () => (await axios.get(listJourneysUrl))?.data?.data;
export const toggleJourney = async (id, is_active) =>
  (await axios.patch(toggleJourneyUrl(id), { is_active }))?.data?.data;
export const updateJourneyStep = async (stepId, patch) =>
  (await axios.put(updateJourneyStepUrl(stepId), patch))?.data?.data;
